import { FC, useCallback } from 'react';
import { useTheme } from '@mui/material';
import ModalDialog from '../../common/components/ModalDialog';
import MakeRelevantContent from './MakeRelevantContent';
import EnablePolicyContent from './EnablePolicyContent';
import RemoveExclusionContent from './RemoveExclusionContent';
import {
  Exclusion,
  ExclusionTypeRaw,
  MakeRelevantType,
} from '../types/exclusion-types';
import MakeRelevantOxContent from './MakeRelevantOxContent';
import { setModalAction } from '../store-actions/exclusions-store-actions';
import { Nullable } from 'common-types';

const ExclusionDialog: FC<React.PropsWithChildren<ExclusionDialogProps>> = ({
  dialogTitle,
  exclusion,
  type,
  open,
}) => {
  const handleClose = useCallback(() => {
    setModalAction(false);
  }, []);

  const theme = useTheme();
  if (!exclusion) {
    return null;
  }
  return (
    <ModalDialog
      onClose={handleClose}
      modalHeader={dialogTitle}
      open={open}
      modalColor={theme.palette.background.paper}>
      {exclusion.exclusionType === ExclusionTypeRaw.policy && (
        <EnablePolicyContent exclusion={exclusion} />
      )}
      {exclusion.exclusionType === ExclusionTypeRaw.alert && (
        <RemoveExclusionContent exclusion={exclusion} />
      )}
      {exclusion.exclusionType === ExclusionTypeRaw.application &&
        (type === MakeRelevantType.Default ? (
          <MakeRelevantOxContent exclusion={exclusion} />
        ) : (
          <MakeRelevantContent exclusion={exclusion} />
        ))}
    </ModalDialog>
  );
};

export interface ExclusionDialogProps {
  dialogTitle: string;
  exclusion: Nullable<Exclusion>;
  type?: MakeRelevantType;
  open: boolean;
}

export default ExclusionDialog;
